import React, { useState, useEffect, useMemo } from "react";
import Helmet from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import FadeLoader from "react-spinners/FadeLoader";
import { Spinner } from "react-bootstrap";
import {
  permissionMetaApi,
  updatePermissionMetaApi,
  deletePermissionMetaRole,
} from "store/actions";
import Table from "components/Table";
import Columns from "./Columns";
import FormikForm from "components/shared/FormikForm";
import AddUpdatePermissionMeta from "components/Modals/AddUpdatePermissionMeta";
import PermissionGate from "components/PermissionGate";
import usePermission from "hooks/usePermission";

const InputFieldsForSearch = [
  {
    name: "search",
    type: "text",
    label: "",
    placeholder: "Search...",
  }
];
const initialValuesForFilter = {
  search: "",
};

const List = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.Auth);
  const { permissionMetaList, totalPermissionMeta, loading } = useSelector((state) => state.Permission);
  const [columns, setcolumns] = useState([{ dataField: "", text: "" }]);
  const [showAddUpdatePop, setShowAddUpdatePop] = useState({
    show: false,
    rowData: null,
  });
  const [filter, setFilter] = useState({
    page: 1,
    limit: 20,
    order: -1,
    orderBy: "createdAt",
    search: "",
  });
  const { hasPermission } = usePermission();
  const permissions = useMemo(() => ({
    add: hasPermission("add_permission_meta"),
    edit: hasPermission("edit_permission_meta"),
    delete: hasPermission("delete_permission_meta"),
  }), [hasPermission]);

  useEffect(() => {
    getApiData(filter);
  }, [filter]);

  useEffect(() => {
    setcolumns(
      Columns({
        permissions,
        onStatusChange: handleStatusChange,
        onEdit: handleEdit,
        onDelete: handleDelete,
        user,
      })?.filter((item) => {
        return true;
      }),
    );
  }, [permissions.edit, permissions.delete, user?.role]);

  async function getApiData(query) {
    try {
      dispatch(permissionMetaApi({ data: query }));
    } catch (error) { }
  }

  const handleFilterForm = (info) => {
    setFilter({
      ...filter,
      page: 1,
      limit: 20,
      order: -1,
      orderBy: "createdAt",
      search: info.search
    });
  };

  const handleConfirmAddUpdate = () => {
    setShowAddUpdatePop({ show: false, rowData: null });
    getApiData(filter);
  };

  const handleEdit = (row) => {
    setShowAddUpdatePop({ show: true, rowData: row });
  };

  const handleDelete = (row) => {
    const confirmed = window.confirm(`Do you want to delete "${row.key}"?`);
    if (!confirmed) return;

    dispatch(
      deletePermissionMetaRole({
        data: { _id: row._id },
        callBack: (err) => {
          if (err) return;
          getApiData(filter);
        },
      }),
    );
  };

  const handleStatusChange = (row) => {
    dispatch(
      updatePermissionMetaApi({
        data: { _id: row._id, isActive: !row.isActive },
        callBack: (err) => {
          if (err) return;
          getApiData(filter);
        },
      }),
    );
  };

  return (
    <>
      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}
      <Helmet title={"Permissions Meta"} />
      {showAddUpdatePop.show && (
        <AddUpdatePermissionMeta
          show={showAddUpdatePop.show}
          title={showAddUpdatePop?.rowData ? "Update Permission Meta" : "Add Permission Meta"}
          loading={loading}
          handleClose={() =>
            setShowAddUpdatePop({ show: false, rowData: null })
          }
          handleConfirm={handleConfirmAddUpdate}
          rowData={showAddUpdatePop?.rowData}
        />
      )}
      <section className="section">
        <div className="section-header">
          <h1>Permissions Meta</h1>
        </div>
        <div className="section-body">
          <div className="card">
            <div className="row justify-content-between">
              <div className="col-6">
                <div className="card-header">
                  <h2 className="section-title">Permission Meta List</h2>
                </div>
              </div>
              <PermissionGate permission="add_permission_meta">
                <div className="col-6">
                  <div className="card-header d-flex justify-content-end align-items-center">
                    <button
                      className="btn btn-primary"
                      onClick={() =>
                        setShowAddUpdatePop({
                          show: true,
                          rowData: null,
                        })
                      }
                    >
                      Add Permission Meta
                    </button>
                  </div>
                </div>
              </PermissionGate>
              <div className="col-12">
                <div className="card-header">
                  <FormikForm
                    initialValues={initialValuesForFilter}
                    onSubmit={handleFilterForm}
                    loading={loading}
                    inputFields={InputFieldsForSearch}
                    buttonText={"Search"}
                  />
                </div>
              </div>
            </div>
          </div>
          {loading && permissionMetaList?.length === 0 && (
            <div className="d-flex justify-content-center align-items-center py-5">
              <Spinner animation="border" role="status" />
            </div>
          )}
          {permissionMetaList?.length > 0 && (
            <Table
              data={permissionMetaList}
              columns={columns}
              setFilter={setFilter}
              total={totalPermissionMeta}
              filter={filter}
            />
          )}
          {!loading && permissionMetaList?.length === 0 && (
            <p style={{ textAlign: "center" }}>No Permission Meta Found</p>
          )}
        </div>
      </section>
    </>
  );
};

export default List;